import {AbstractCrudApiService} from '@shared/abstracts/abstract-crud-api.service';
import { urlJoin } from '@shared/utils/url.utils';

export abstract class AbstractAuthorityService<Model, CreateDto, UpdateDto> extends AbstractCrudApiService<Model, CreateDto, UpdateDto> {

  override get endpoint(): string {
    return `${this.api$.value}/:authorityId`;
  }

  protected constructor() {
    super();
    this.api$.next(urlJoin(this.env.get('api.base'), 'authorities'));
    this.logger.debug(this.name, 'Endpoint', this.endpoint);
  }
}
